import { useQuery } from '@hooks/reactQuery';

import { getAssetHistoryUserFilter } from '@api/assetLogs';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedByName } from '@utils/formatter';

import { IShortUserInfo } from '@interfaces/user/user';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { ASSET_HISTORY_USERS } from '@constants/queryKeys';

export const useQueryAssetHistoryUsersOptions = (assetId?: string) => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IShortUserInfo[], TSelectOptionType[]>({
		queryKey: [ASSET_HISTORY_USERS, assetId],
		queryFn: extractQueryParams(getAssetHistoryUserFilter),
		select: (data) => optionsFormattedByName(data || []),
		enabled: [assetId],
		refetchOnWindowFocus: false,
	});

	return {
		usersOptions: data || [],
		isLoadingUsersOptions: isInitialLoading,
	};
};
